import { SVGIcon } from '@/types';
import { FooterInfo } from '@/store/store.types';

/**
 *  A step of the tool.
 */
export enum Step {
    /** The introduction. */
    Intro = 'intro',

    /** The first step: configuring the spaces. */
    Spaces = 'spaces',

    /** The second step: selecting suggested systems per space. */
    Systems = 'systems',

    /** The third step: selecting service and extra products. */
    Products = 'products',

    /** The fourth step: the overview. */
    Overview = 'overview',

    /** The fifth and final step: filling in personal details and requesting an offer. */
    PersonalDetails = 'personal-details',
}

/**
 *  Holding the details of the back button of a step.
 */
export interface StepBack {
    /** The step to navigate back to. */
    step: Step;

    /** The label that is shown in the button. */
    label: string;

    /**
     *  The title of the back button, always suffixing the sentence: "Go back to {title}"
     */
    title: string;
}

/**
 *  Holding the details of a step's tile on the landing.
 */
export interface StepTile {
    /** The text that is rendered in the tile. */
    text: string;

    /** The (large) icon of the step */
    icon: SVGIcon;
}

/**
 *  Holding the details of a step in the progress bar.
 */
export interface StepConfig {
    /** The index of the step. */
    index: number;

    /** The name of the step, as used for the routing. */
    name: string;

    /** The anchor title for the step. */
    title: string;

    /** The label that is used for the step. */
    label: string;

    /**
     *
     *  The action of the step, used to suffix the
     *  label with to contruct the footer's next
     *  button's content.
     *
     *  "{label} {action}"
     *
     *  E.g.: "Ruimtes instellen"
     *
     */
    action: string;

    /** The key of the getter for the header's badge counter. */
    badgeGetter?: string;

    /** Details of the SVG to render as icon. */
    icon: SVGIcon;

    /** The details for going back. */
    back?: StepBack;

    /** Default additional info for the step which shows in the footer. */
    info?: FooterInfo;

    /** The details of the step's tile on the landing. */
    tile: StepTile;
}

/**
 *  Holding a map with a config per step.
 */
export interface Steps {
    [step: string]: StepConfig;
}
